import { Button } from "primereact/button";
import { Divider } from "primereact/divider";
import { InputText } from "primereact/inputtext";
import { InputNumber } from "primereact/inputnumber";
import { SelectButton } from "primereact/selectbutton";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Dialog } from "primereact/dialog";
import ManagePicture from "./ManagePicture";
import { useFormik } from "formik";
import { Calendar } from "primereact/calendar";

export default function AddVarientForm({
  formik,
  setShowVarientForm,
  setValidateVarient,
  showVarientForm,
  editingVarient,
  setEditingVarient,
  specificProduct,
}) {
  const [dialogVisible, setDialogVisible] = useState(false);
  const [isTouched, setIsTouched] = useState(false);
  const [properties, setProperties] = useState([]);
  const [currentVariantImages, setCurrentVariantImages] = useState([]);
  const [variantImagesMarkedForDeletion, setVariantImagesMarkedForDeletion] = useState([]);
  const { enableCurrency } = useSelector((state) => state.CurrencyReducer);
  const [discountType, setDiscountType] = useState(editingVarient?.discount_type || 'fixed');

  const variantImageFormik = useFormik({
    initialValues: {
      variantImages: [],
    },
    onSubmit: () => {
     
    },
  });

  useEffect(() => {
    setCurrentVariantImages(variantImageFormik.values.variantImages || []);
  }, [variantImageFormik.values.variantImages]);

  useEffect(() => {
    if (editingVarient) {
      formik.setValues({
        ...formik.values,
        varient: {
          ...formik.values.varient,
          quantity: editingVarient.quantity || 0,
          purchasePrice: editingVarient.purchasePrice || 0,
          price: editingVarient.price || 0,
          discount: editingVarient.discount || 0,
          shipment_charges: editingVarient.shipment_charges || 0,
        },
      });
      setProperties(editingVarient.properties || []);
      setCurrentVariantImages(editingVarient.images || []);
      setDiscountType(editingVarient.discount_type || 'fixed');
    } else {
      setProperties([]);
      variantImageFormik.setFieldValue("variantImages", []);
      setVariantImagesMarkedForDeletion([]);
      setDiscountType('fixed');
      formik.setValues({
        ...formik.values,
        varient: {
          properties: [],
          quantity: 0,
          price: formik?.values?.samePrice ? formik?.values?.price : 0,
          purchasePrice: formik?.values?.samePurchasePrice ? formik?.values?.purchasePrice : 0,
          discount: formik?.values?.sameDiscount ? formik?.values?.discount : 0,
          shipment_charges: 0,
        }
      });
    }
    variantImageFormik.setTouched({}, false);
  }, [editingVarient]);

  const handleAddProperty = () => {
    if (properties.length >= 12) {
      toast.error("Maximum 12 properties allowed");
      return;
    }
    setProperties([...properties, { name: "", value: "" }]);
  };

  const handleRemoveProperty = (index) => {
    const newProperties = properties.filter((_, i) => i !== index);
    setProperties(newProperties);
  };

  const handlePropertyChange = (index, field, value) => {
    const newProperties = [...properties];
    newProperties[index] = {
      ...newProperties[index],
      [field]: value
    };
    setProperties(newProperties);
  };

  const handleClear = () => {
    setShowVarientForm(false);
    setValidateVarient(false);
    setEditingVarient(null);
    setIsTouched(false);
    setProperties([]);
    formik.setValues({
      ...formik.values,
      varient: {
        properties: [],
        quantity: 0,
        price: formik?.values?.samePrice ? formik?.values?.price : 0,
        purchasePrice: formik?.values?.samePurchasePrice ? formik?.values?.purchasePrice : 0,
        discount: formik?.values?.sameDiscount ? formik?.values?.discount : 0,
        shipment_charges: 0,
      },
    });
  };

  const updateVarientInArray = (updatedVarient) => {
    const index = formik.values.varients.findIndex(
      (varient) => varient.id === editingVarient.id
    );

    if (index !== -1) {
      formik.values.varients[index] = {
        ...formik.values.varients[index],
        ...updatedVarient,
        id: editingVarient.id,
        properties: properties.map(prop => ({
          name: prop.name,
          value: prop.value
        })),
        images: currentVariantImages,
        imagesToDelete: variantImagesMarkedForDeletion,
        discount_type: discountType,
        shipment_charges: formik.values.varient.shipment_charges || 0,
      };
    }

    formik.setValues({
      ...formik.values,
      varient: {
        properties: [],
        price: formik?.values?.samePrice ? formik?.values?.price : 0,
        purchasePrice: formik?.values?.samePurchasePrice ? formik?.values?.purchasePrice : 0,
        discount: formik?.values?.sameDiscount ? formik?.values?.discount : 0,
        discount_type: 'fixed',
        shipment_charges: 0,
        images: [],
        imagesToDelete: [],
      },
    });

    setEditingVarient(null);
    setShowVarientForm(false);
    setIsTouched(false);
    setProperties([]);
    setCurrentVariantImages([]);
    variantImageFormik.resetForm();
    setVariantImagesMarkedForDeletion([]);
    setDiscountType('fixed');

    toast.success("Variant Updated Successfully!");
  };

  const updateVarient = () => {
    if (editingVarient) {
      formik.validateForm().then((errors) => {
        if (Object.keys(errors)?.length === 0) {
          if (formik.isValid) {
            updateVarientInArray({
              ...formik.values.varient,
              properties: properties.map(prop => ({
                name: prop.name,
                value: prop.value
              }))
            });
          }
        } else {
          formik.handleSubmit();
          console.log("Validation errors:", errors);
        }
      });
    }
  };

  const handleAddVarient = () => {
    formik.validateForm().then((mainFormErrors) => {
      const variantRelatedErrors = mainFormErrors.varient;
      variantImageFormik.validateForm().then(imageErrors => {
        if (!variantRelatedErrors && Object.keys(imageErrors).length === 0) {
          const varientsArray = Array.isArray(formik.values.varients)
            ? formik.values.varients
            : [];

          // Get the next available ID
          const nextId = varientsArray.length > 0 
            ? Math.max(...varientsArray.map(v => v.id)) + 1 
            : 1;

          const newVarient = {
            ...formik.values.varient,
            properties: properties.map(prop => ({
              name: prop.name,
              value: prop.value
            })),
            id: nextId,
            images: currentVariantImages,
            imagesToDelete: [],
            discount_type: discountType,
            shipment_charges: formik.values.varient.shipment_charges || 0,
          };

          formik.setValues({
            ...formik.values,
            varients: [...varientsArray, newVarient],
            varient: {
              properties: [],
              price: formik?.values?.samePrice ? formik?.values?.price : 0,
              purchasePrice: formik?.values?.samePurchasePrice ? formik?.values?.purchasePrice : 0,
              discount: formik?.values?.sameDiscount ? formik?.values?.discount : 0,
              discount_type: 'fixed',
              shipment_charges: 0,
              images: [],
              imagesToDelete: [],
            },
          });

          setShowVarientForm(false);
          setValidateVarient(false);
          setIsTouched(false);
          setProperties([]);
          setCurrentVariantImages([]);
          variantImageFormik.resetForm();
          setVariantImagesMarkedForDeletion([]);
          setDiscountType('fixed');
          toast.success("Variant Added Successfully!");
        } else {
          if (variantRelatedErrors) formik.setErrors({ ...formik.errors, varient: variantRelatedErrors });
          variantImageFormik.setTouched(Object.keys(imageErrors).reduce((acc, key) => ({...acc, [key]: true }), {}));
          variantImageFormik.setErrors(imageErrors);
          toast.error("Please correct the errors before adding the variant.");
        }
      });
    });
  };

  return (
    <>
      <div className="mt-3 flex justify-end gap-3">
        <Button
          label="Add Variant"
          icon="pi pi-plus"
          className="p-primary-btn"
          onClick={() => {
            setShowVarientForm(true);
            setValidateVarient(true);
            setIsTouched(false);
          }}
          type="button"
        />
      </div>

      {showVarientForm && (
        <div className="card shadow-md rounded-lg p-4 mt-4">
          <Divider>
            <span className="text-2xl font-bold p-font-style text-center text-black mx-1">
              {editingVarient ? "Edit" : "Add"} Variant
            </span>
          </Divider>

          <div className="px-4 gap-8">
            {/* Properties Section */}
            <div className="mb-6">
              <div className="flex justify-between items-center mb-4">
                <h3 className="text-lg font-semibold">Properties</h3>
                <Button
                  label="Add Property"
                  icon="pi pi-plus"
                  className="p-button-sm"
                  onClick={handleAddProperty}
                  disabled={properties.length >= 12}
                  type="button"
                />
              </div>
              
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                {properties.map((property, index) => (
                  <div key={index} className="flex gap-2 items-end">
                    <div className="flex-1">
                      <label className="block text-sm font-medium mb-1">Property Name</label>
                      <InputText
                        value={property.name}
                        onChange={(e) => handlePropertyChange(index, 'name', e.target.value)}
                        placeholder="e.g., Size, Color, Material"
                        className="w-full"
                      />
                    </div>
                    <div className="flex-1">
                      <label className="block text-sm font-medium mb-1">Value</label>
                      <InputText
                        value={property.value}
                        onChange={(e) => handlePropertyChange(index, 'value', e.target.value)}
                        placeholder="e.g., Large, Red, Cotton"
                        className="w-full"
                      />
                    </div>
                    <Button
                      icon="pi pi-times"
                      className="p-button-danger p-button-sm"
                      onClick={() => handleRemoveProperty(index)}
                      type="button"
                    />
                  </div>
                ))}
              </div>
            </div>

            {/* Price and Quantity Section */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              <div className="">
                <div className="flex flex-col gap-2">
                  <label htmlFor="varient.purchasePrice">Purchase Price</label>
                  <span className="w-full">
                    <InputNumber
                      id="varient.purchasePrice"
                      name="varient.purchasePrice"
                      className="w-full text-lg p-primary-input"
                      value={
                        formik?.values?.samePurchasePrice
                          ? formik?.values?.purchasePrice
                          : formik?.values?.varient?.purchasePrice || 0
                      }
                      onValueChange={formik.handleChange}
                      prefix={`rs`}
                      disabled={formik.values.samePurchasePrice}
                    />
                  </span>
                </div>
              </div>

              <div className="">
                <div className="flex flex-col gap-2">
                  <label htmlFor="varient.price">Sale Price</label>
                  <span className="w-full">
                    <InputNumber
                      id="varient.price"
                      name="varient.price"
                      className="w-full text-lg p-primary-input"
                      value={
                        formik?.values?.samePrice
                          ? formik?.values?.price
                          : formik?.values?.varient?.price || 0
                      }
                      onValueChange={formik.handleChange}
                      prefix={`${enableCurrency?.unit || ""} `}
                      disabled={formik.values.samePrice}
                    />
                  </span>
                </div>
              </div>

              <div className="">
                <div className="flex flex-col gap-2">
                  <label htmlFor="varient.shipment_charges">Shipment Charges</label>
                  <span className="w-full">
                    <InputNumber
                      id="varient.shipment_charges"
                      name="varient.shipment_charges"
                      className="w-full text-lg p-primary-input"
                      value={formik?.values?.varient?.shipment_charges || 0}
                      onValueChange={formik.handleChange}
                      prefix={`${enableCurrency?.unit || ""} `}
                    />
                  </span>
                </div>
              </div>

              <div className="">
                <div className="flex flex-col gap-2">
                  <label htmlFor="varient.quantity">Quantity</label>
                  <span className="w-full">
                    <InputNumber
                      id="varient.quantity"
                      name="varient.quantity"
                      className="w-full text-lg p-primary-input"
                      value={formik?.values?.varient?.quantity || 0}
                      onValueChange={formik.handleChange}
                      min={0}
                      disabled={true}
                    />
                  </span>
                </div>
              </div>

              <div className="">
                <div className="flex flex-col gap-2">
                  <label htmlFor="varient.specialPrice">Special Price</label>
                  <span className="w-full">
                    <InputNumber
                      id="varient.specialPrice"
                      name="varient.specialPrice"
                      className="w-full text-lg p-primary-input"
                      value={formik?.values?.varient?.specialPrice || 0}
                      onValueChange={formik.handleChange}
                      prefix={`${enableCurrency?.unit || ""} `}
                    />
                  </span>
                  {/* Start/End Date for Special Price */}
                  {formik?.values?.varient?.specialPrice > 0 && (
                    <div className="flex gap-2 mt-2">
                      <Calendar
                        id="varient.specialPriceStart"
                        name="varient.specialPriceStart"
                        value={formik?.values?.varient?.specialPriceStart || null}
                        onChange={formik.handleChange}
                        placeholder="Start Date"
                        showIcon
                        className="w-full"
                      />
                      <Calendar
                        id="varient.specialPriceEnd"
                        name="varient.specialPriceEnd"
                        value={formik?.values?.varient?.specialPriceEnd || null}
                        onChange={formik.handleChange}
                        placeholder="End Date"
                        showIcon
                        className="w-full"
                      />
                    </div>
                  )}
                </div>
              </div>

              <div className="">
                <div className="flex flex-col gap-2">
                  <label htmlFor="varient.sellerSku">Seller SKU</label>
                  <span className="w-full">
                    <InputText
                      id="varient.sellerSku"
                      name="varient.sellerSku"
                      className="w-full text-lg p-primary-input"
                      value={formik?.values?.varient?.sellerSku || ''}
                      onChange={formik.handleChange}
                      placeholder="Enter Seller SKU"
                    />
                  </span>
                </div>
              </div>

              <div className="">
                <div className="flex flex-col gap-2">
                  <label htmlFor="varient.discount">Discount</label>
                  <div className="flex flex-col gap-2">
                    <SelectButton
                      value={discountType}
                      onChange={(e) => setDiscountType(e.value)}
                      options={[
                        { label: 'Fixed', value: 'fixed' },
                        { label: 'Percentage', value: 'percentage' }
                      ]}
                      className="mb-2"
                    />
                    <span className="w-full">
                      <InputNumber
                        inputId="varient.discount"
                        name="varient.discount"
                        value={formik.values.varient.discount}
                        onValueChange={(e) => {
                          setIsTouched(true);
                          formik.setFieldValue("varient.discount", e.value);
                        }}
                        minFractionDigits={enableCurrency?.decimal_places || 2}
                        maxFractionDigits={enableCurrency?.decimal_places || 2}
                        suffix={discountType === 'percentage' ? '%' : enableCurrency?.unit || '$'}
                        disabled={formik?.values?.sameDiscount}
                        placeholder={`Enter Discount ${discountType === 'percentage' ? '(%)' : `(${enableCurrency?.unit || '$'})`}`}
                        className={formik.errors.varient?.discount && isTouched ? "p-invalid" : ""}
                      />
                      {formik.errors.varient?.discount && isTouched && (
                        <small className="p-error">
                          {formik.errors.varient?.discount}
                        </small>
                      )}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-8">
            <div className="flex justify-end gap-4">
              <Button
                label="Clear"
                icon="pi pi-times"
                className="p-red-btn"
                type="button"
                onClick={handleClear}
              />
              <Button
                label={editingVarient ? "Edit" : "Add"}
                icon="pi pi-check"
                className="p-secondary-btn"
                onClick={() => {
                  if (editingVarient) {
                    updateVarient();
                  } else {
                    handleAddVarient();
                  }
                  setIsTouched(true);
                }}
                type="button"
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
}
